// ============================================================================
// FollowupChips — suggested follow-up prompts after the last assistant turn
// Capsule chips: IBM Plex Mono 10px uppercase, glass fill, meanBlue 50%
// border. Clicking sends the text as a user message; the row vanishes when
// the user starts typing (handled by the host via conditional render).
// ============================================================================

import { Box, ButtonBase } from '@mui/material'
import { beoflowColors, typography, spacing, borderRadius } from '@/theme/muiTheme'

interface FollowupChipsProps {
  followups: string[]
  onSelect: (text: string) => void
}

export default function FollowupChips({ followups, onSelect }: FollowupChipsProps) {
  if (!followups.length) return null
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing.xs,
        px: spacing.sm,
        mb: spacing.md,
      }}
    >
      {followups.map(text => (
        <ButtonBase
          key={text}
          onClick={() => onSelect(text)}
          sx={{
            borderRadius: borderRadius.round,
            backgroundColor: 'rgba(248, 246, 244, 0.05)',
            border: `1px solid ${beoflowColors.meanBlue}80`, // meanBlue at 50%
            px: spacing.md,
            py: '4px',
            fontFamily: typography.fontFamilyMonospace,
            fontSize: '10px',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
            color: 'text.primary',
            textAlign: 'left',
            transition: 'background-color 150ms ease',
            '&:hover': { backgroundColor: 'rgba(74, 155, 184, 0.14)' },
          }}
        >
          {text}
        </ButtonBase>
      ))}
    </Box>
  )
}
